import { defineComponent as _defineComponent } from 'vue';
const __default__ = {
    name: "DescribeObjectStore",
};
import { computed, ref, watch } from "vue";
import { QuotaSourceUsageProvider } from "@/components/User/DiskUsage/Quota/QuotaUsageProvider.js";
import ConfigurationMarkdown from "./ConfigurationMarkdown.vue";
import ObjectStoreBadges from "./ObjectStoreBadges.vue";
import ObjectStoreRestrictionSpan from "./ObjectStoreRestrictionSpan.vue";
import QuotaUsageBar from "@/components/User/DiskUsage/Quota/QuotaUsageBar.vue";
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        storageInfo: null,
        what: null
    },
    setup(__props, { expose }) {
        const props = __props;
        const quotaSourceLabel = computed(() => props.storageInfo.quota?.source);
        const isPrivate = computed(() => props.storageInfo.private);
        const badges = computed(() => props.storageInfo.badges);
        const userDefined = computed(() => props.storageInfo.object_store_id?.startsWith("user_objects://"));
        const quotaUsageProvider = ref(null);
        watch(props, async () => {
            if (quotaUsageProvider.value) {
                // @ts-ignore
                quotaUsageProvider.value.update({ quotaSourceLabel: quotaSourceLabel.value });
            }
        });
        expose({
            isPrivate,
        });
        return { __sfc: true, props, quotaSourceLabel, isPrivate, badges, userDefined, quotaUsageProvider, QuotaSourceUsageProvider, ConfigurationMarkdown, ObjectStoreBadges, ObjectStoreRestrictionSpan, QuotaUsageBar };
    }
});
